import { Box, styled } from "@mui/material";
import { StyleguideSavioColors } from "../../configuration/themeSettings";

export const PartListBox = styled(Box, { label: "part-list_Box" })
    (({ theme }) => ({
        zIndex: "unset",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 285px)",
        left: "auto",
        WebkitOverflowScrolling: "touch",

        '@media print': {
            '> .MuiTableContainer-root':{
                paddingRight:0,
            },
          },

        "table tbody tr:hover td a":{
            color: StyleguideSavioColors.blue,
            //textDecorationColor: StyleguideSavioColors.blue,
        }

      
    }))